import * as types from './mutation-types';

export default {
  info({ commit }, message) {
    commit(types.SEND_TOAST, {
      title: 'Info',
      type: 'info',
      message,
    });
  },
  success({ commit }, message) {
    commit(types.SEND_TOAST, {
      title: 'Success',
      type: 'success',
      message,
    });
  },
  warning({ commit }, message) {
    commit(types.SEND_TOAST, {
      title: 'Warning',
      type: 'warning',
      message,
    });
  },
  error({ commit }, message) {
    commit(types.SEND_TOAST, {
      title: 'Error',
      type: 'error',
      message,
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/toast/actions.js